import { ChevronLeft, ChevronRight } from 'lucide-react';

export const CarouselNavButtons = ({ onPrevious, onNext }) => (
  <>
    <button
      onClick={onPrevious}
      className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 sm:-translate-x-4 z-20 bg-white rounded-full p-2 sm:p-3 shadow-lg hover:bg-gray-100 hover:shadow-xl transition-all"
      data-testid="carousel-prev-button"
      aria-label="Previous article"
    >
      <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" />
    </button>
    <button
      onClick={onNext}
      className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 sm:translate-x-4 z-20 bg-white rounded-full p-2 sm:p-3 shadow-lg hover:bg-gray-100 hover:shadow-xl transition-all"
      data-testid="carousel-next-button"
      aria-label="Next article"
    >
      <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" />
    </button>
  </>
);
